"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetFootprintVenuesRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class GetFootprintVenuesRequestDto {
  constructor() {
    this.pageIndex = 0;
  }
}
exports.GetFootprintVenuesRequestDto = GetFootprintVenuesRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  default: 0
}), __metadata("design:type", Number)], GetFootprintVenuesRequestDto.prototype, "pageIndex", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Case-insensitive venue name filter.'
}), __metadata("design:type", String)], GetFootprintVenuesRequestDto.prototype, "query", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  enum: enums_1.VenueType,
  description: 'Only venues of this type.'
}), __metadata("design:type", String)], GetFootprintVenuesRequestDto.prototype, "type", void 0);
//# sourceMappingURL=GetFootprintVenuesRequest.dto.js.map